export function checkIfInIframe(): void {
    if (window.self !== window.top) {
        document.body.classList.add('in-iframe');
    }
}